import { useState } from 'react'
import { motion } from 'framer-motion'
import Reveal from './Reveal'

const proximos = [
  {
    num: '01',
    name: 'Neumología Intensiva',
    desc: 'Ventilación mecánica, manejo del EPOC y falla respiratoria aguda. Lanzamiento estimado: Agosto 2026.',
    tag: 'Lista de espera abierta',
  },
  {
    num: '02',
    name: 'Semiología Avanzada',
    desc: 'El arte de examinar un paciente con precisión diagnóstica. Lanzamiento estimado: Octubre 2026.',
    tag: 'Lista de espera abierta',
  },
]

// Minimal SVG helix decoration
function HelixDecor() {
  return (
    <svg
      width="200" height="400" viewBox="0 0 200 400"
      className="absolute right-0 top-0 h-full opacity-[0.04] pointer-events-none"
      fill="none" preserveAspectRatio="xMidYMid slice"
    >
      {Array.from({ length: 16 }).map((_, i) => {
        const y = i * 26
        const x0 = 100 + Math.sin((i / 16) * Math.PI * 4) * 60
        const x1 = 100 + Math.sin((i / 16) * Math.PI * 4 + Math.PI) * 60
        return (
          <g key={i}>
            <line x1={x0} y1={y} x2={x1} y2={y} stroke="#C9A84C" strokeWidth="0.8"/>
            <circle cx={x0} cy={y} r="3" fill="#C9A84C"/>
            <circle cx={x1} cy={y} r="3" fill="#C9A84C" opacity="0.5"/>
          </g>
        )
      })}
    </svg>
  )
}

export default function ProximosCursos() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!email) return
    setSubmitted(true)
  }

  return (
    <section
      id="proximos"
      className="relative overflow-hidden"
      style={{ padding: '120px 5vw', background: 'var(--bg)' }}
    >
      <HelixDecor />

      <div className="relative z-10">
        <Reveal>
          <div className="section-label">Próximos cursos</div>
          <h2
            className="font-display font-black leading-[1.04] tracking-[-0.02em] mb-16"
            style={{ fontSize: 'clamp(2.2rem, 4vw, 3.5rem)', color: 'var(--ink)' }}
          >
            Lo que se viene<br />
            en{' '}
            <em className="not-italic" style={{ color: 'var(--gold)' }}>2026</em>.
          </h2>
        </Reveal>

        {/* Cards */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 mb-16"
          style={{ gap: '1px', background: 'var(--line)' }}
        >
          {proximos.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col justify-between gap-6 group"
              style={{ background: 'var(--bg)', padding: '48px' }}
            >
              <div>
                <div
                  className="font-display font-black leading-none mb-4"
                  style={{ fontSize: '3rem', color: 'var(--ink-4)' }}
                >
                  {p.num}
                </div>
                <h3
                  className="font-display font-black text-[22px] mb-2.5"
                  style={{ color: 'var(--ink)' }}
                >
                  {p.name}
                </h3>
                <p
                  className="font-body font-light text-[14px] leading-[1.8]"
                  style={{ color: 'var(--ink-2)' }}
                >
                  {p.desc}
                </p>
                <div className="flex items-center gap-2 mt-4">
                  <div
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ background: 'var(--gold)' }}
                  />
                  <span
                    className="font-display font-bold text-[10px] tracking-[0.14em] uppercase"
                    style={{ color: 'var(--gold)' }}
                  >
                    {p.tag}
                  </span>
                </div>
              </div>
              <motion.span
                className="font-display font-black text-[24px] self-end"
                style={{ color: 'var(--ink-4)' }}
                whileHover={{ color: 'var(--gold)' }}
                transition={{ duration: 0.2 }}
              >
                →
              </motion.span>
            </motion.div>
          ))}
        </div>

        {/* Waitlist */}
        <Reveal delay={0.15}>
          {submitted ? (
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              className="flex items-center gap-4"
            >
              <div
                className="w-2 h-2 rounded-full"
                style={{ background: 'var(--gold)' }}
              />
              <span
                className="font-display font-semibold text-[14px] tracking-[0.04em]"
                style={{ color: 'var(--ink-2)' }}
              >
                ¡Listo! Te avisamos cuando abra la inscripción.
              </span>
            </motion.div>
          ) : (
            <form onSubmit={handleSubmit} className="flex max-w-[520px]">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Tu correo electrónico"
                required
                className="flex-1 font-body text-[14px] px-5 py-3.5"
                style={{
                  background: 'var(--bg-3)',
                  border: '1px solid var(--line)',
                  borderRight: 'none',
                  color: 'var(--ink)',
                }}
                onFocus={e => e.target.style.borderColor = 'rgba(201,168,76,0.5)'}
                onBlur={e => e.target.style.borderColor = 'var(--line)'}
              />
              <button
                type="submit"
                className="font-display font-black text-[11px] tracking-[0.1em] uppercase px-7 py-3.5 shrink-0 transition-colors duration-150"
                style={{ background: 'var(--gold)', color: '#000' }}
                onMouseEnter={e => e.target.style.background = '#E2C47A'}
                onMouseLeave={e => e.target.style.background = 'var(--gold)'}
              >
                Anotarme
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  )
}